import { Layout } from 'antd'
import React from 'react'
import { Outlet } from 'react-router-dom'
import PublicFooterXS from '../Footer/PublicFooterXS'
import { Color } from '../../../Common/Color'
import MobilePublicHeader from '../Header/Mobile/MobilePublicHeader'

export default function MobileCompleteLayout () {
  return (
    <Layout>
      <MobilePublicHeader withSearch={true} />
      <Layout.Content style={{ overflowY: 'scroll', backgroundColor: Color.white }}>
        <Outlet />
      </Layout.Content>
      <PublicFooterXS />
    </Layout>
  )
}
